import { render, staticRenderFns } from "./CreateSav.vue?vue&type=template&id=1c916342&scoped=true"
import script from "./CreateSav.vue?vue&type=script&lang=js"
export * from "./CreateSav.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c916342",
  null
  
)

export default component.exports